import React from 'react';
import { FixedDropdown } from './FixedDropdown';
import { OptionsPanelContent } from './OptionsPanelContent';
import type { PanelDataState, ImageUrlByPresetType, PresetType } from './useAIProductStagingData';

// OptionsPanelMobile - Mobile version using Dialog
// Displays options in a modal dialog

interface OptionsPanelMobileProps {
	activePanel: string | null;
	title: string;
	onClose: () => void;
	options: {
		background?: PanelDataState;
		surface?: PanelDataState;
		mood?: PanelDataState;
		effect?: PanelDataState;
		person?: PanelDataState;
		pose?: PanelDataState;
	};
	isLoading?: boolean;
	selectedValues: {
		background?: number | null;
		surface?: number | null;
		mood?: number | null;
		effect?: number | null;
		person?: number | null;
		pose?: number | null;
	};
	onSelect: (type: PresetType, value: number | null) => void;
	imageUrl?: ImageUrlByPresetType;
	setImageUrl?: React.Dispatch<React.SetStateAction<ImageUrlByPresetType>>;
	handleUpload?: (presetType: PresetType) => void;
	supportsUpload?: boolean;
	required?: boolean;
	allowCustomBackground?: boolean;
	modalType?: 'product-staging' | 'virtual-tryon';
	menuId: string;
	onWebcamOpen?: () => void;
}

export const OptionsPanelMobile: React.FC<OptionsPanelMobileProps> = ({
	activePanel,
	title,
	onClose,
	options,
	isLoading = false,
	selectedValues,
	onSelect,
	imageUrl,
	setImageUrl,
	handleUpload,
	supportsUpload,
	required = false,
	allowCustomBackground = true,
	modalType = 'product-staging',
	menuId,
	onWebcamOpen,
}) => {
	if (!activePanel) return null;

	return (
		<FixedDropdown onClose={onClose}>
			<OptionsPanelContent
				activePanel={activePanel}
				options={options}
				isLoading={isLoading}
				selectedValues={selectedValues}
				onSelect={onSelect}
				imageUrl={imageUrl}
				setImageUrl={setImageUrl}
				handleUpload={handleUpload}
				supportsUpload={supportsUpload}
				required={required}
				allowCustomBackground={allowCustomBackground}
				modalType={modalType}
				menuId={menuId}
				onWebcamOpen={onWebcamOpen}
			/>
		</FixedDropdown>
	);
};
